import * as actionType from './actionTypes';

export function setAuthState(state:string) {
  return {
    type: actionType.SET_AUTH_STATE,
    payload: state,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setDefaultOrganisation(organisation:any) {
  return {
    type: actionType.SET_DEFAULT_SITE,
    payload: organisation,
  }
}

export function authEmployee(employee:{}) {
  return {
    type: actionType.AUTHORISE_EMPLOYEE,
    payload: employee,
  }
}

export function setUser(user:{}) {
  return {
    type: actionType.SET_USER,
    payload: user,
  }
}

export function setToken(token:string) {
  return {
    type: actionType.SET_TOKEN,
    payload: token,
  }
}

export function setDispatcherToken(token:string) {
  return {
    type: actionType.SET_DISPATCHER_TOKEN,
    payload: token,
  }
}

export function unauthEmployee() {
  return {
    type: actionType.UNAUTHORISE_EMPLOYEE,
  }
}